import { IForm } from "../service/IForm";
import * as Yup from "yup";
import axios from "axios";
import { MutableRefObject } from "react";
import { FormHandles } from "@unform/core";

interface RequestDTO {
  message: string;
  protocolo: string;
}

Yup.setLocale({
  mixed: {
    default: "Não é válido",
    required: "Este campo é obrigatório",
    notType: "Insira uma informação válida",
  },
  date: {
    min: "O orfão deve possuir menos de 21 anos",
  },
});

export const handleFormSubmit = async (
  ref: MutableRefObject<FormHandles>,
  data: IForm,
  setModalOpen: any,
  setProtocolo: any,
  setStatus: any,
  setLoading: any,
  toast: any
) => {
  try {
    ref.current?.setErrors({});

    const dataSchema = {};

    for (let prop in data) {
      if (prop === "cras_document" ||
       prop === "social_report" ||
       prop === "death_certificate_father" ||
       prop === "death_certificate_mother" ||
       prop === "social_security_certificate") continue;

      if (typeof data[prop] === "string") {
        const hasBirthDate = prop.search("orphans_birth");
        const hasGender = prop.search("orphans_gender");
        const hasCPF = prop.search("document_id");

        if (hasBirthDate >= 0) {
          dataSchema[prop] = Yup.date().min("01/01/2000").required();
          continue;
        }

        if (hasGender >= 0) {
          dataSchema[prop] = Yup.string().test(
            "empty-check",
            "Este campo é obrigatório",
            (child_gender) => child_gender.length > 0
          );

          continue;
        }

        if (hasCPF >= 0) {
          dataSchema[prop] = Yup.string()
            .test("len", "Informação incompleta", (val) => val.length === 14)
            .required();
          continue;
        }

        dataSchema[prop] = Yup.string().required();
      } else {
        if (prop === "proof_income") {
          dataSchema[prop] = Yup.mixed().test(
            "lenArray",
            "Campo obrigatório",
            (val) => val.length > 0
          );
        } else {
          dataSchema[prop] = Yup.mixed().required();
        }
      }
    }

    const schema = Yup.object().shape({
      ...dataSchema,
    });

    await schema.validate(data, {
      abortEarly: false,
    });

    const formData = new FormData();
    for (let key in data) {
      const arrobaPos = key.search("@");

      if (arrobaPos >= 0) {
        const newKey = key.slice(0, arrobaPos);
        formData.append(newKey, data[key]);
      } else if (key === "proof_income") {
        const numFiles = data[key].length;

        for (let i = 0; i < numFiles; i++) {
          formData.append(key, data[key][i]);
        }
      } else {
        formData.append(key, data[key]);
      }
    }

    setLoading(true);

    axios
      .post<RequestDTO>(
        "https://api.cuidar.sedes.ma.gov.br/requirements",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        const numProtocolo = res.data.protocolo;
        setStatus("success");
        setProtocolo(numProtocolo);

        localStorage.setItem(
          "@info-protocol",
          JSON.stringify({
            name: data.name,
            protocol: numProtocolo,
          })
        );

        setLoading(false);
        setModalOpen(true);
        ref.current.reset();
      })
      .catch((err) => {
        setStatus("error");
        setLoading(false);
        setModalOpen(true);
      });
  } catch (err) {
    const validationErrors = {};

    if (err instanceof Yup.ValidationError) {
      err.inner.forEach((error) => {
        validationErrors[error.path] = error.message;
      });

      ref.current?.setErrors(validationErrors);
      toast.error(
        "Revise o formulário. Existem campos com informações incompletas ou não fornecidas",
        {
          duration: 10000,
        }
      );
    }
  }
};
